module.exports = __webpack_public_path__ + "img/fondo-banner-principal.1f552139.jpg";